/* eslint-disable */
export const SIDEBAR_PERSIST_KEY = `bds:sidebar`;

/**
 * The width of the `<Sidebar />`. This value was taken from [Google Calendar](https://calendar.google.com). This is how wide their sidebar is
 * @type {number}
 */
export const SIDEBAR_WIDTH = 256;
